import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import {
    DatepickerComponent,
    DropdownAutocompleteComponent,
    DropdownComponent,
    FileInputComponent,
    FormErrorListComponent,
    InputComponent,
    InputDurationComponent,
    InputNumberComponent,
    SearchAutocompleteComponent,
    SwitchComponent,
    TextareaComponent,
    ToolScanComponent
} from './';


import { ScannerDirective } from '@app/shared/directives/scanner.directive';
import { HIDScannerDirective } from "@app/shared/directives/hidscanner.directive";
import { InputPasswordComponent } from './input-password/input-password.component';
import { InputEmailComponent } from './input-email/input-email.component';
import { MultipleInputComponent } from './multiple-input/multiple-input.component';
import { InputCheckboxComponent } from './input-checkbox/input-checkbox.component';
import { StatusTriStateCheckboxComponent } from './status-tri-state-checkbox/status-tri-state-checkbox.component';
import { SearchBarComponent } from '@app/shared/components';
import { FileUploadModule } from "primeng/fileupload";
import { AutoCompleteModule } from "primeng/autocomplete";
import { PrimeNGLibraryModule } from "@components/_libraries/_primeng-library.module";
import { NGXLibraryModule } from "@components/_libraries/_ngx-library.module";
import { TooltipComponent } from "@app/shared/components";
import { IconComponent } from "@components/form/icon/icon.component";
import { InputRadioComponent } from "@components/form/input-radio/input-radio.component";

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        FileUploadModule,
        AutoCompleteModule,
        PrimeNGLibraryModule,
        NGXLibraryModule,
    ],
    declarations: [
        InputComponent,
        InputNumberComponent,
        InputDurationComponent,
        DatepickerComponent,
        DropdownComponent,
        SwitchComponent,
        FormErrorListComponent,
        FileInputComponent,
        TextareaComponent,
        ToolScanComponent,
        ScannerDirective,
        HIDScannerDirective,
        DropdownAutocompleteComponent,
        InputPasswordComponent,
        InputEmailComponent,
        MultipleInputComponent,
        InputCheckboxComponent,
        StatusTriStateCheckboxComponent,
        SearchBarComponent,
        SearchAutocompleteComponent,
        TooltipComponent,
        IconComponent,
        InputRadioComponent
    ],
    exports: [
        InputComponent,
        InputNumberComponent,
        InputPasswordComponent,
        InputEmailComponent,
        InputDurationComponent,
        DatepickerComponent,
        DropdownComponent,
        SwitchComponent,
        FormErrorListComponent,
        FileInputComponent,
        TextareaComponent,
        ToolScanComponent,
        ScannerDirective,
        HIDScannerDirective,
        DropdownAutocompleteComponent,
        SearchAutocompleteComponent,
        MultipleInputComponent,
        SearchBarComponent,
        InputCheckboxComponent,
        StatusTriStateCheckboxComponent,
        TooltipComponent,
        IconComponent,
        InputRadioComponent
    ]
})
export class FormFeatureModule {

}
